if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        // this.init();
        FoxTheme.Motion.inView(this, this.init.bind(this));

        this.onPositionPick = this.onPositionPick.bind(this);
        document.addEventListener('click', this.onPositionPick);
        document.addEventListener('change', this.onPositionPick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onPositionPick);
        document.removeEventListener('change', this.onPositionPick);
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
          this.initImageZoom(allMedia);
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        // Pase automatico de la galeria (ajuste enable_gallery_autoplay de la seccion).
        this.autoplayEnabled =
          this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;
        if (this.autoplayEnabled) {
          this.sliderOptions.autoplay = {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          const sliderModules = [FoxTheme.Swiper.Thumbs];
          if (this.autoplayEnabled && FoxTheme.Swiper.Autoplay) sliderModules.push(FoxTheme.Swiper.Autoplay);
          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, sliderModules);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
          this.handleAutoplay();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom(items = []) {
        let dataSource = [];
        if (items.length > 0) {
          items.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
          preload: [1, 4],
        });

        if (this.autoplayEnabled) {
          this.lightbox.on('beforeOpen', () => {
            this.lightboxPausedAutoplay = true;
            this.applyAutoplayState();
          });
          this.lightbox.on('close', () => {
            this.lightboxPausedAutoplay = false;
            this.applyAutoplayState();
          });
        }

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data }) => {
          if (data.src) {
            return data.src;
          }
          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }

          this.updateMediaCounter(swiper);
        });
      }

      updateMediaCounter(swiper) {
        const current = this.querySelector('[data-media-counter-current]');
        if (!current) return;

        const index = (typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex) + 1;
        current.textContent = String(index).padStart(2, '0');
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.updateAutoplayForSlide(slides[activeIndex]);
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }

          this.updateMediaCounter(swiper);
        });
      }

      handleAutoplay() {
        const swiper = this.sliderInstance.slider;
        if (!this.autoplayEnabled || !swiper.autoplay) return;
        this.userPausedAutoplay = false;
        this.mediaPausedAutoplay = false;
        this.autoplayToggle = this.querySelector('[data-autoplay-toggle]');
        if (this.autoplayToggle && !this.autoplayToggle.dataset.bound) {
          this.autoplayToggle.dataset.bound = 'true';
          this.autoplayToggle.hidden = false;
          this.autoplayToggle.addEventListener('click', () => {
            this.userPausedAutoplay = !this.userPausedAutoplay;
            this.applyAutoplayState();
          });
        }
        // Los videos se quedan en pantalla el triple de tiempo que una foto.
        swiper.slides.forEach((slide) => {
          const type = slide.dataset.mediaType;
          if (type === 'video' || type === 'external_video') {
            slide.setAttribute('data-swiper-autoplay', this.autoplayDelay * 3);
          }
        });
        // Si el cliente pulsa la portada del video o entra en el reproductor, el pase se detiene.
        this.addEventListener('click', (event) => {
          if (event.target.closest('.media__poster, .deferred-media__poster')) {
            this.mediaPausedAutoplay = true;
            this.applyAutoplayState();
          }
        });
        window.addEventListener('blur', () => {
          setTimeout(() => {
            const active = document.activeElement;
            if (active && active.tagName === 'IFRAME' && this.contains(active)) {
              this.mediaPausedAutoplay = true;
              this.applyAutoplayState();
            }
          }, 0);
        });
        const { slides, activeIndex } = swiper;
        if (slides[activeIndex]) this.updateAutoplayForSlide(slides[activeIndex]);
        this.applyAutoplayState();
      }

      // El modelo 3D detiene el pase por si mismo. En los videos el pase continua (con una
      // espera mas larga, ver handleAutoplay) y solo se detiene si el cliente toca el video.
      updateAutoplayForSlide(slide) {
        if (!this.autoplayEnabled || !slide) return;
        const type = slide.dataset.mediaType;
        this.mediaPausedAutoplay = type === 'model';
        this.applyAutoplayState();
      }

      applyAutoplayState() {
        const swiper = this.sliderInstance && this.sliderInstance.slider;
        if (!swiper || !swiper.autoplay) return;
        const shouldRun = !this.userPausedAutoplay && !this.mediaPausedAutoplay && !this.lightboxPausedAutoplay;
        if (shouldRun) {
          if (!swiper.autoplay.running) swiper.autoplay.start();
        } else if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
        this.classList.toggle('autoplay-running', shouldRun);
        if (this.autoplayToggle) {
          const paused = !!this.userPausedAutoplay;
          this.autoplayToggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          this.autoplayToggle.classList.toggle('is-paused', paused);
          const label = paused ? this.autoplayToggle.dataset.labelPlay : this.autoplayToggle.dataset.labelPause;
          if (label) this.autoplayToggle.setAttribute('aria-label', label);
        }
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant) {
        if (variant && variant.featured_media) {
          if (this.sliderInstance.slider) {
            const slideIndex = variant.featured_media.position || 0;
            this.sliderInstance.slider.slideToLoop(slideIndex - 1, 0, false);
          } else {
            this.sortMediaItems(variant);
          }
          return;
        }

        this.setOrientationMedia(variant);
      }

      // Salto automatico por formato: si la medida elegida es horizontal, la galeria se
      // coloca en la foto del formato horizontal y vuelve a la primera foto al volver a una
      // medida vertical. La foto se localiza por su texto alternativo o por su nombre de
      // archivo: basta que contengan "horizontal".
      setOrientationMedia(variant) {
        if (!variant) return;

        const keyword = 'horizontal';
        const optionsText = (variant.options && variant.options.length ? variant.options.join(' ') : variant.title || '')
          .toString()
          .toLowerCase();
        const isHorizontal = optionsText.includes(keyword);
        const orientation = isHorizontal ? 'horizontal' : 'vertical';

        if (this.currentOrientation === orientation) return;
        const isFirstRun = this.currentOrientation === undefined;
        this.currentOrientation = orientation;
        // En vertical solo actuamos si el cliente venia de una medida horizontal.
        if (!isHorizontal && isFirstRun) return;

        const mediaItems = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        const target = isHorizontal
          ? mediaItems.find((media) =>
              `${media.dataset.mediaAlt || ''} ${media.dataset.mediaFile || ''}`.toLowerCase().includes(keyword)
            )
          : mediaItems[0];

        this.goToMedia(target, isHorizontal);
      }

      goToMedia(mediaItem, allowScroll = false) {
        if (!mediaItem) return;

        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.slideToLoop(Number(mediaItem.dataset.mediaIndex) || 0, 0, false);
        } else if (allowScroll) {
          mediaItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      // Al pulsar una posición de instalación (opción «Posición de instalación» de la
      // ficha o campo posicion_instalacion del configurador), la galería va al dibujo
      // de las posiciones: la foto cuyo texto alternativo o nombre de archivo lleva
      // «posiciones». Si la galería queda fuera de la pantalla (móvil), sube hasta ella.
      onPositionPick(event) {
        if (!event.isTrusted) return;
        const section = this.closest('.shopify-section');
        if (!section || !section.contains(event.target)) return;

        const field = event.target.closest('.configurator-field, .product-form__input');
        if (!field) return;
        const control = field.querySelector('select[data-config-key], input[type="radio"], select');
        if (!control || !/posici[oó]n/i.test(`${control.dataset.configKey || ''} ${control.name || ''}`)) return;

        const target = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')].find((media) =>
          /posiciones/i.test(`${media.dataset.mediaAlt || ''} ${media.dataset.mediaFile || ''}`)
        );
        if (!target) return;

        this.goToMedia(target, true);
        this.revealGallery();

        // En la ficha normal, al cambiar de variante product-info.js devuelve el foco a la
        // opción pulsada y la página vuelve a bajar: se sube otra vez cuando acaba. Si la
        // variante no cambia (posición ya elegida), se olvida a los 4 s.
        if (field.matches('.product-form__input') && !this.revealAfterVariant) {
          const done = () => {
            document.removeEventListener('variant:changed', this.revealAfterVariant);
            clearTimeout(this.revealAfterVariantTimer);
            this.revealAfterVariant = null;
          };
          this.revealAfterVariant = () => {
            done();
            setTimeout(() => this.revealGallery(), 50);
          };
          document.addEventListener('variant:changed', this.revealAfterVariant);
          this.revealAfterVariantTimer = setTimeout(done, 4000);
        }
      }

      revealGallery() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;
        const rect = this.getBoundingClientRect();
        if (rect.bottom < 80 || rect.top > window.innerHeight - 80) {
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        this.initImageZoom(newMedias);

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
